//#region src/v2/blocks/request-block/helpers/group-by.ts
function groupBy(arr, key, transform) {
	const groups = {};
	Object.setPrototypeOf(groups, null);
	for (const item of arr) {
		const groupKey = item[key];
		const value = transform ? transform(item) : item;
		const group = groups[groupKey];
		if (group) group.push(value);
		else groups[groupKey] = [value];
	}
	return groups;
}
//#endregion
export { groupBy };

//# sourceMappingURL=group-by.js.map